import AppBarTitle from "@main-components/app-bar-title";
import ErrorIcon from "@material-ui/icons/Report";
import * as React from "react";
import { useTranslate } from "react-admin";

const ErrorPage = ({ error, errorInfo, ...rest }) => {
  const translate = useTranslate();
  return (
    <div>
      <AppBarTitle title="Error" />
      <h1>
        <ErrorIcon /> Something Went Wrong{" "}
      </h1>
      <div>A client error occurred and your request couldn't be completed.</div>
      {process.env.NODE_ENV !== "production" && (
        <details>
          <h2>{translate(error.toString())}</h2>
          {errorInfo.componentStack}
        </details>
      )}
      <div>
        {/*  <Button
          variant="contained"
          icon={<History />}
          onClick={() => history.go(-1)}
        >
          Back
        </Button> */}
      </div>
    </div>
  );
};

export default ErrorPage;
